import { useState } from 'react';
import Hero from './components/Hero';
import ExclusiveSession from './components/ExclusiveSession';
import SolutionsShowcase from './components/SolutionsShowcase';
import VideoTestimonials from './components/VideoTestimonials';
import PilotTimeline from './components/PilotTimeline';
import MeetTheLeaders from './components/MeetTheLeaders';
import FinalConversion from './components/FinalConversion';
import FAQ from './components/FAQ';
import DownloadModal from './components/DownloadModal';
import BookingModal from './components/BookingModal';
import MeetingModal from './components/MeetingModal';
import DinnerModal from './components/DinnerModal';
import RegistrationModal from './components/RegistrationModal';
import LeaderBookingModal from './components/LeaderBookingModal';

export default function HomePage() {
  const [downloadModalOpen, setDownloadModalOpen] = useState(false);
  const [downloadType, setDownloadType] = useState<'brochure' | 'brief'>('brochure');
  const [bookingModalOpen, setBookingModalOpen] = useState(false);
  const [meetingModalOpen, setMeetingModalOpen] = useState(false);
  const [dinnerModalOpen, setDinnerModalOpen] = useState(false);
  const [registrationModalOpen, setRegistrationModalOpen] = useState(false);
  const [leaderModalOpen, setLeaderModalOpen] = useState(false);
  const [selectedLeader, setSelectedLeader] = useState('');

  const handleDownloadClick = (type: 'brochure' | 'brief') => {
    setDownloadType(type);
    setDownloadModalOpen(true);
  };

  const handleLeaderBooking = (leaderName: string) => {
    setSelectedLeader(leaderName);
    setLeaderModalOpen(true);
  };

  return (
    <div className="min-h-screen bg-white">
      <Hero 
        onRegister={() => setRegistrationModalOpen(true)} 
        onBookSession={() => setBookingModalOpen(true)} 
      />
      <ExclusiveSession 
        onRegister={() => setRegistrationModalOpen(true)}
        onBookMeeting={() => setLeaderModalOpen(true)}
      />
      <SolutionsShowcase />
      <VideoTestimonials />
      <PilotTimeline />
      <MeetTheLeaders onBookLeader={handleLeaderBooking} />
      <FinalConversion 
        onRegister={() => setRegistrationModalOpen(true)} 
        onBookSession={() => setBookingModalOpen(true)}
        onDownload={handleDownloadClick}
        onDinnerInvite={() => setDinnerModalOpen(true)}
        onScheduleMeeting={() => setMeetingModalOpen(true)}
      />
      <FAQ />

      <DownloadModal 
        isOpen={downloadModalOpen} 
        onClose={() => setDownloadModalOpen(false)} 
        type={downloadType}
      />
      <BookingModal 
        isOpen={bookingModalOpen} 
        onClose={() => setBookingModalOpen(false)} 
      />
      <MeetingModal 
        isOpen={meetingModalOpen} 
        onClose={() => setMeetingModalOpen(false)} 
      />
      <DinnerModal 
        isOpen={dinnerModalOpen} 
        onClose={() => setDinnerModalOpen(false)} 
      />
      <RegistrationModal 
        isOpen={registrationModalOpen} 
        onClose={() => setRegistrationModalOpen(false)} 
      />
      <LeaderBookingModal
        isOpen={leaderModalOpen}
        onClose={() => setLeaderModalOpen(false)}
        leaderName={selectedLeader}
      />
    </div>
  );
}
